import gql from 'graphql-tag'

export const GET_ARTICLE_BOX_LIST_QUERY = gql`
  query GetArticleBoxList(
    $numberOfBoxes: Int!
    $startIndex: Int!
    $tagNames: [String!]!
    $mustIncludeAllTags: Boolean!
    $categoryNames: [String!]!
    $articleIds: [Int!]!
  ) {
    articleBoxList(
      numberOfBoxes: $numberOfBoxes
      startIndex: $startIndex
      tagNames: $tagNames
      mustIncludeAllTags: $mustIncludeAllTags
      categoryNames: $categoryNames
      articleIds: $articleIds
    ) {
      articles {
        title
        categoryName
        mainImage {
          url
          relativeUrl
          height
        }
        postDateText
        summary
        url
      }
      blogUrl
    }
  }
`
